import React, { useRef, useState } from 'react';
import {
   Box,
   Button,
   Grid,
   IconButton,
   Paper,
   Typography,
   Backdrop,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import { AlertLabel, Input, TextArea } from '../../../assets/styled/Element';
import { Controller, useForm } from 'react-hook-form';
import Axios from 'axios';
import LoadingPopup from '../../Loading/LoadingPopup';
import ErrorPopup from '../../Error/ErrorPopup';
import { useSnackbar } from 'notistack';
import { TitleLabel } from '../../Element/LabelInputForm';
import { reverseFormatNumber } from '../../../configs/helpers/utility';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';

const useStyles = makeStyles((theme) => ({
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
   },
   paper: {
      padding: theme.spacing(2, 4, 3),
      width: '500px',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
   listStyle: {
      height: '65px',
   },
   flexGrid: {
      display: 'flex',
      alignItems: 'center',
   },
   qrPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
   },
   detailRight: {
      height: '280px',
      overflow: 'auto',
   },
}));

const Delete = (props) => {
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const closeRef = useRef();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
   } = useForm({});
   const onSubmit = (e) => {
      let payload = {
         permissionGroupId: props.data.permissionGroupId,
      };
      Axios.post('/GSB/dashboard/permission/DeletePermissionGroup', payload)
         .then(() => {
            enqueueSnackbar('ลบกลุ่มผู้ใช้งานสำเร็จ', {
               variant: 'success',
            });
            props.onSuccess();
         })
         .catch((e) => {
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            setIsLoading(false);
         });
   };
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <form onSubmit={handleSubmit(onSubmit)}>
         <Paper className={classes.paper}>
            <Backdrop className={classes.backdrop} open={isLoading}>
               <LoadingPopup />
            </Backdrop>
            <div className={classes.header}>
               <Typography variant={'h4'}>ลบสิทธิ์พนักงาน</Typography>
               <IconButton
                  className={classes.headerL}
                  size={'small'}
                  onClick={props.onClickClose}
                  ref={closeRef}
               >
                  <FontAwesomeIcon icon={faTimesCircle} />
               </IconButton>
            </div>
            <Box
               display={'flex'}
               alignItems={'flex-start'}
               flexDirection={'column'}
               fontSize={20}
            >
               <Box display={'flex'} width={'100%'}>
                  <Grid container spacing={1}>
                     <Grid item xs={12}>
                        <TitleLabel>ยืนยันการลบสิทธิ์ </TitleLabel>
                     </Grid>
                  </Grid>
               </Box>
               <Box mt={3}>
                  <Box>
                     <Button
                        onClick={handleSubmit}
                        variant={'contained'}
                        color={'primary'}
                        type={'submit'}
                     >
                        ยืนยัน
                     </Button>
                     <Button variant={'contained'} onClick={props.onClickClose}>
                        ยกเลิก
                     </Button>
                  </Box>
               </Box>
            </Box>
         </Paper>
      </form>
   );
};

export default Delete;
